<div class="containerGridVerif">
    <div class="item">
        <div class="neg">
            Claro le ofrece la forma más segura de suscripción para continuar su afiliación.
        </div>
        <div>
            Por favor seleccione el número de suscriptor o correo electrónico donde desea recibir su código de seguridad.
        </div>
        <div class="optchoice" [ngClass]="{'on': this.radio[0] == true}" (click)="optionSendCode(1,'email')" *ngIf="this.email!='' && this.email!=null">
            <div class="opt1" >
                <input type="radio" class="option" [checked]="this.radio[0] == true" id="option1" name="option"
                    (click)="optionSendCode(1,'email')">
            </div>
            <div class="opt2">
                <label for="option1">
                    Correo electrónico registrado
                    <br>
                    <span class="neg">
                        {{this.emailShow}}
                    </span>
                </label>
            </div>
        </div>
        <div class="optchoice" [ngClass]="{'on': this.radio[1] == true}" (click)="optionSendCode(2,'movil')" *ngIf="this.subscriber!='' && this.subscriber!=null">
            <div class="opt1">
                <input type="radio" class="option" [checked]="this.radio[1] == true" id="option2" name="option"
                    (click)="optionSendCode(2,'movil')">
            </div>
            <div class="opt2">
                <label for="option2">
                    Número de suscriptor registrado
                    <br>
                    <span class="neg">
                        ******{{this.subscriber | slice:-4}}
                    </span>
                </label>
            </div>
        </div>
        <div>
            <div class="basicrow text-center m-top">
                <a class="btns def-i red pull-right vcenter"
                    [ngClass]="{'red': this.radio[0] == true || this.radio[1] == true,'gray': this.radio[0] == false && this.radio[1] == false}"
                    (click)="this.sendCode();">
                    <span class="tabcell">
                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
                <a (click)="this.cancel()" ui-sref="netflix" class="btns def-i gray pull-left vcenter">
                    <span class="tabcell">
                        Cancelar
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>